﻿export const Login = (() => {

	const Init = () => {

		var input = document.getElementById('Input_Email');
		if (input) {
			input.addEventListener('change', Login);
			input.addEventListener('blur', Login);
			input.addEventListener('focus', Login);
			input.addEventListener('keydown', Login);
		}
	}

	const Login = () => {
		if ((document.getElementById('Input_Email') as HTMLInputElement).value.indexOf('@shareit.net.au') !== -1)
			(document.getElementById('staff-account') as HTMLFormElement).submit();
	};

	return { Init };

})();

document.addEventListener('DOMContentLoaded', () => {
	Login.Init();
});
